$.onmount('[data-component=subscriptions-apply-coupon-modal]', function() {
  $(this).on('click', function() {
    var modalTarget = $(this).data('target');
    var modalElement = $('[data-modal=' + modalTarget + ']');
    modalElement.modal('show');
  });
});
